import { Component } from '@angular/core';
import { ControlBase } from '../../base/control-base/control-base.component';

@Component({
    selector: 'gear-loading-control',
    templateUrl: 'gear-loading.control.html',
    styleUrl: './gear-loading.control.scss',
    standalone: false,
})
export class GearLoadingControl extends ControlBase {}
